import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Col, Row, message } from 'antd';
import { IconButton, Avatar, Loader } from 'Common/components';
import AddToCartButton from '../AddToCartButton'



export const CartItem = props => {
    const propTypes = {
        settings: PropTypes.object.isRequired,
        prod: PropTypes.shape({
            _id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            price: PropTypes.number.isRequired,
            price_was: PropTypes.number.isRequired,
            // tax_value: PropTypes.number,
            // tax_unit: PropTypes.string,
            tax_total: PropTypes.number,
            limit_max_qty_in_cart: PropTypes.number,
            picture_thumb: PropTypes.string,
            qty: PropTypes.number,

            attributes: PropTypes.arrayOf(
                PropTypes.shape({
                    _id: PropTypes.string,
                    title: PropTypes.string,
                    show_in_store: PropTypes.number,
                    value: PropTypes.string,
                    displayAs: PropTypes.string,
                })
            ),
        }).isRequired

    }

    const [loading, setLoading] = React.useState(false);
    const { prod, settings } = props;

    const onDelete = args => {
        setLoading(true)
        props.onDelete(prod).then(r => {
            if (r === true) setLoading(false)
        })
    }

    const renderAttributes = (item) => {
        console.log("renderAttributes()", { title: item.title, product_id: item.product_id, attributes: item.attributes })


        if (!item.attributes) return null;
        return item.attributes.map((o, i) => {
            // if (o.value && o.show_in_store == 1) return <span key={i}>{o.title} {o.value}</span>
            // if (o.value && o.show_in_store == 1) return <span key={i}>{o.value} {o.title}</span>
            if (o.value && o.show_in_store == 1) return <span key={i}>{o.value} {o.code}</span>
            return null;
        })
    }

    let out_of_stock = (prod.available_qty < 1);
    let low_stock = (prod.available_qty > 0 && prod.qty > prod.available_qty);
    if (low_stock) console.log("low_stock: ", prod.title)


    return (<Loader loading={loading} key={prod.product_id}><div className="cart-contents-cartitem">

        <Row align="middle">
            <Col className="prod-image-holder" style={{marginRight:"5px"}}>
                <Avatar src={prod.picture_thumb ? `${process.env.REACT_APP_DATA_URL}/${prod.picture_thumb}` : undefined} size={62} shape="square" />
                {out_of_stock && <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)', position: 'absolute', width: '100%', height: '100%', top: '-0px', left: '-0px', display: 'flex', alignItems: "center", justifyContent: "center" }}>
                    <div style={{ backgroundColor: '#CCC', width:"100%", textAlign:"center", fontSize: '10px', padding: '0px 3px' }}>Sold Out</div>
                </div>}
                {(!out_of_stock && low_stock) && <div style={{ backgroundColor: 'rgba(255, 255, 255, 0.3)', position: 'absolute', width: '100%', height: '100%', top: '-0px', left: '-0px', display: 'flex', alignItems: "center", justifyContent: "center" }}>
                    <div style={{ backgroundColor: '#CCC', width:"100%", textAlign:"center", fontSize: '10px', padding: '0px 3px' }}>Low Stock</div>
                </div>}
            </Col>
            <Col flex="auto" className="prod-details">
                <div className="pro-title" to={`/product/${prod.slug}`}>{prod.title}</div>
                <div className="prod-attribute">{renderAttributes(prod)}</div>
                <span style={{marginTop:"5px"}}><AddToCartButton prod={{ ...prod }} size="small" /></span>
            </Col>
            <Col flex="auto" className="prod-qty">
                <span>
                    {prod.price_was && prod.price_was > 0 && prod.price_was > prod.price && <div className="price-cut tag">Price Cut</div> || null}
                    <div>{prod.qty} x {prod.price}</div>
                </span>
            </Col>
            {props.onDelete && 
                <Col flex="auto" className="prod-cost" align="right">
                    <div>
                        <IconButton icon="times" onClick={onDelete} style={{ paddingBottom: "1px" }} />
                        <div>{settings.currency} {prod.price * prod.qty}</div>
                    </div>
                </Col>
            }
        </Row>
    </div></Loader>)
}

export default CartItem;